import React, { useEffect } from "react"
import types from "prop-types"
import { useSelector } from "react-redux"
import { getUsers } from "reduxSlices/formBuilderSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable max-len */
import TaskUserSelector from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskUserSelector"
/* eslint-enable max-len */

const TaskAssigneeSelector = ({ className = "" }) => {
  const users = useSelector(getUsers)

  const { addAssigneeId, taskAssigneeIds, taskMemberIds } = useTaskFormContext()

  useEffect(() => {
    window.dispatchEvent(new window.Event("resize"))
  }, [taskAssigneeIds.length])

  const selectableUsers = users.reduce((userList, user) => {
    if (user.active && !taskAssigneeIds.includes(user.id)) {
      userList.push(
        {
          ...user,
          ...(taskMemberIds.includes(user.id) && { marker: "Member" }),
        },
      )
    }
    return userList
  }, [])

  return (
    <TaskUserSelector
      addUserId={addAssigneeId}
      className={className}
      taskUserType="Users"
      users={selectableUsers}
    />
  )
}

TaskAssigneeSelector.propTypes = {
  className: types.string,
}

export default TaskAssigneeSelector
